import { render, staticRenderFns } from "./AtivaçãoLeads.vue?vue&type=template&id=62d15cbe&scoped=true&"
import script from "./AtivaçãoLeads.vue?vue&type=script&lang=js&"
export * from "./AtivaçãoLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d15cbe",
  null
  
)

export default component.exports